<template>
  <v-row justify="center">
    <v-dialog persistent v-model="show">
      <v-row justify="center">
        <v-col cols="9" style="">
          <div
            id="receiptData"
            style="
              background: white;
              max-width: 800px;
              padding: 7px;
              margin-left: 28%;
            "
          >
            <body>
              <div id="page-wrap">
                <v-row>
                  <v-col>
                    <v-row>
                      <!-- image -->
                      <v-col
                        cols="2"
                        lg="2"
                        xl="2"
                        md="2"
                        style="margin-left: 3%; margin-top: 0%"
                      >
                        <img
                          v-if="!imagelink"
                          style="height: 150px; width: 150px"
                          src="../../assets/img/nallai_logo.png"
                        />
                        <img
                          v-if="imagelink"
                          style="height: 150px; width: 150px"
                          :src="imagelink"
                        />
                      </v-col>
                      <!-- Shop Details -->
                      <v-col
                        cols="5"
                        xl="5"
                        md="5"
                        lg="5"
                        style="margin-left: 4%; margin-top: 1%"
                      >
                        <b
                          v-if="SaleDetails && SaleDetails.shop"
                          style="color: black; font-size: 17px"
                        >
                          {{ SaleDetails.shop.name }}</b
                        ><br />

                        <span style="color: black; font-size: 14px">
                          <strong>Address : </strong>
                          {{
                            SaleDetails.shop.address
                              ? SaleDetails.shop.address.address_line1
                              : '----'
                          }}
                          <br />
                          <strong> Phone No : </strong>
                          {{
                            SaleDetails.shop.contact
                              ? SaleDetails.shop.contact.phone
                              : '-----'
                          }}
                          <br />
                          <strong> Mail : </strong>
                          {{
                            SaleDetails.shop.contact
                              ? SaleDetails.shop.contact.email
                              : '-----'
                          }}
                          <br />
                          <strong>Date : </strong>
                          {{ new Date().toLocaleString() }}.
                        </span>
                      </v-col>
                      <!-- Sales order details -->
                      <v-col
                        style="margin-left: 0%; margin-top: 1%"
                        cols="4"
                        xl="4"
                        md="4"
                        lg="4"
                      >
                        <b
                          v-if="SaleDetails"
                          style="color: black; font-size: 17px"
                        >
                          Sales Order</b
                        >
                        <br />
                        <span style="color: black; font-size: 14px">
                          <strong> Invoice No : </strong>

                          {{ SaleDetails.reference_number }}

                          <br />
                          <strong> Customer : </strong>

                          {{
                            SaleDetails.customer
                              ? SaleDetails.customer.name
                              : ''
                          }}
                          <br />
                          <strong> Date : </strong>
                          {{ new Date(SaleDetails.date).toLocaleString() }}
                          <br />
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <!-- product table -->
                <table class="table" style="margin-top: 2%">
                  <thead>
                    <tr>
                      <th colspan="7" style="color: black"><b>Products</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Product</td>
                      <td>Batch</td>
                      <td>Unit</td>
                      <td>Quantity</td>
                      <td style="text-align: right">Price</td>
                      <td style="text-align: right">Discount</td>
                      <td class="pr-2" style="text-align: right">SubTotal</td>
                    </tr>
                    <tr v-for="(item, index) in ProductDatas" :key="index">
                      <td v-if="item && item.product">
                        {{ item.product.name }}
                      </td>
                      <td v-if="item.batch && item">{{ item.batch.batch }}</td>
                      <td v-if="item && item.unit">{{ item.unit.name }}</td>
                      <td>{{ item.quantity }}</td>
                      <td style="text-align: right">
                        {{ item.amount | formatCurrency }}
                      </td>
                      <td style="text-align: right">
                        {{ item.discount_amount | formatCurrency }}
                      </td>
                      <td class="pr-2" style="text-align: right">
                        {{
                          (item.amount * item.quantity - item.discount_amount)
                            | formatCurrency
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style="page-break-after: auto"></p>

                <!-- Final Total -->
                <v-row
                  style="
                    page-break-inside: avoid;
                    background-color: rgba(151, 0, 60, 0);
                  "
                >
                  <v-col cols="4" xl="4" md="4" lg="4">
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 20px;
                          padding-left: 15%;
                        "
                        >Total</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 30px;
                          padding-left: 15%;
                          color: #b91158;
                        "
                        >Rs.
                        {{ SaleDetails.grand_total | formatCurrency }}</v-col
                      ></v-row
                    >
                  </v-col>
                  <!-- No of items -->
                  <v-col cols="4" xl="4" md="4" lg="4">
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 20px;
                          padding-left: 15%;
                        "
                        >No of Items</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 30px;
                          padding-left: 15%;
                          color: #b91158;
                        "
                        >{{ ProductDatas.length }}</v-col
                      ></v-row
                    >
                  </v-col>
                  <!-- Sub total -->
                  <v-col cols="2" xl="2" md="2" lg="2" style="font-size: 16px">
                    <v-row
                      ><v-col style="text-align: right"
                        >SubTotal :</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >Discount :</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >Additional :</v-col
                      ></v-row
                    >
                  </v-col>
                  <v-col cols="2" xl="2" md="2" lg="2" style="font-size: 16px">
                    <v-row
                      ><v-col style="text-align: right">{{
                        SaleDetails.total | formatCurrency
                      }}</v-col></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >- {{ SaleDetails.discount_amount }}</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >+
                        {{
                          TotalAdditionalAmount
                            ? TotalAdditionalAmount
                            : '0' | formatCurrency
                        }}</v-col
                      ></v-row
                    >
                  </v-col>
                </v-row>
                <br />

                <!-- Payments table -->
                <table class="table">
                  <thead>
                    <tr>
                      <th colspan="5" style="color: black"><b>Payments</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Reference No</td>
                      <td>Date Time</td>
                      <td>Type</td>

                      <td>Amount</td>
                      <td>Status</td>
                    </tr>
                    <tr v-for="(item, index) in PaymentDetails" :key="index">
                      <td>
                        {{
                          item.reference_number ? item.reference_number : '...'
                        }}
                      </td>
                      <td>{{ new Date(item.created_at).toLocaleString() }}</td>
                      <td>{{ item.payment_type }}</td>
                      <td>{{ item.amount }}</td>
                      <td>{{ item.status }}</td>
                    </tr>
                  </tbody>
                </table>

                <!-- Prepared By, Date  -->
                <div style="page-break-inside: avoid">
                  <v-row>
                    <v-col
                      cols="6"
                      lg="6"
                      xl="6"
                      md="6"
                      style="margin-left: 3%; margin-top: 5%"
                    >
                      ---------------------------------- <br />
                      <p style="color: black; font-size: 13px">Prepared By</p>
                    </v-col>
                    <v-col
                      cols="5"
                      lg="5"
                      xl="5"
                      md="5"
                      style="margin-top: 5%; text-align: right"
                    >
                      ------------------------------<br />
                      <p style="color: black; font-size: 13px">Date</p>
                    </v-col>
                  </v-row>
                  <!-- Authorized by -->
                  <v-row>
                    <v-col
                      cols="11"
                      lg="11"
                      xl="11"
                      md="11"
                      style="margin-left: 3%; margin-top: 2%; text-align: right"
                    >
                      ------------------------------<br />
                      <p style="color: black; font-size: 13px">Authorized By</p>
                    </v-col>
                  </v-row>
                </div>

                <div style="text-align: center">
                  <p style="font-weight: bold">Thank You</p>
                  <p>&#169;www.speedcodelabs.com || &#9742; 0212211599</p>
                </div>
                <p style="page-break-after: always"></p>
              </div>
            </body>
          </div>
        </v-col>
        <v-col cols="3">
          <v-row>
            <v-col cols="12">
              <v-btn height="32" width="160" outline @click="openPrint">
                <v-icon class="icon_small mr-2" dark>print</v-icon>Print
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn height="32" width="160" outline disabled>
                <v-icon class="icon_small mr-2" dark>mail</v-icon> Mail
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                height="32"
                width="160"
                color="red"
                outline
                @click="closePreview"
              >
                <v-icon class="icon_small mr-2" style="color: white" dark
                  >close</v-icon
                ><span style="color: white"> Close </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      ReservationDetails: [],
      dialog: false,
      value: [],
      options: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapState(['imagelink']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.SaleDetails);
        }
      },
    },
  },
  mounted() {
    this._keyListener = function (e) {
      if (e.key == 'Escape') {
        this.$emit('closePreview');
      }
    };

    document.addEventListener('keydown', this._keyListener.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener);
  },
  props: {
    ProductDatas: {
      type: Array,
      default: [],
    },
    PaymentDetails: {
      type: Array,
      default: [],
    },
    SaleDetails: {
      type: Object,
      default: {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closePreview() {
      this.$emit('closePreview');
    },
    openPrint() {
      this.$htmlToPaper('receiptData');
    },
  },
};
</script>
<style scoped>
table {
  margin: 40px 0px;
  font-size: 1rem;
  color: rgb(0, 0, 0);
  font-weight: 700;
  /* border: 1px solid rgb(0, 0, 0); */
  background-color: #fff;
  width: 100%;
  text-align: center;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 6px;
  overflow: hidden;
}

table thead {
  background-color: rgb(0, 0, 0);
  font-size: 2rem;
  color: #fff;
  letter-spacing: 0.3rem;
}

table td,
table th {
  /* border-bottom: 1px solid rgb(7, 7, 7) !important; */
  height: 60px;
  width: calc(100% / 7);
  vertical-align: middle !important;
}

table thead th + th,
table tbody td {
  /* border-right: 1px solid #333 !important; */
}

table tbody td:nth-child(6) {
  border-right: none;
}

table th {
  font-size: 14px;
}

table td,
table th {
  height: 50px;
}
.example {
  background-color: #eee;
  width: 200px;
  height: 100px;
  border: 1px dotted black;
  overflow-y: scroll; /* Add the ability to scroll */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.example::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.example {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
